import {DataSource, FilterSchema} from "../dataSources/DataSource";

import {TaskListUnit} from "../../API";

import {listTaskListUnits} from "./requests/listTaskListUnits";

import {onCreateTaskListUnit, onUpdateTaskListUnit, onDeleteTaskListUnit} from "../../graphql/tasks/subscriptions";
import { BasicDataSourceDeps } from "../../platform/services/types/DataSourceDependencies";


export class TaskListUnitDS extends DataSource<TaskListUnit, TaskListUnit, BasicDataSourceDeps> {
    readonly _modelName = 'TaskListUnit' as const;
    wsId: string;
    _subscriptionGQLs = {
        onCreate: onCreateTaskListUnit,
        onUpdate: onUpdateTaskListUnit,
        onDelete: onDeleteTaskListUnit,
    }

    constructor(deps: BasicDataSourceDeps, wsId: string) {
        super(deps);
        this.setSortRule('name');
        this.wsId = wsId;
    }

    get syncHash() {
        return this.wsId;
    }

    get syncQueryFilter() {
        return {
            workspaceId: {
                eq: this.wsId
            },
        }
    }

    getTaskListUnitById(id: string) {
        return this.allRows.find(unit => unit.id === id);
    }

    getFilterDefaultValues(): {} {
        return {}
    }

    getFilterSchema(): FilterSchema<TaskListUnit> {
        return {
            name: {
                type: 'client',
                apply: (workspace: TaskListUnit) => (
                    this.filterValues.name === undefined
                    || workspace.name?.toLowerCase().indexOf(this.filterValues.name.toLowerCase()) !== -1
                ),
            },
        }
    }

    loadGQLFetch() {
        return listTaskListUnits(
            this.deps.dataClientService,
            this.deps.authService,
            this.wsId
        );
    };

    loadMoreGQLFetch(nextToken: string) {
        return listTaskListUnits(
            this.deps.dataClientService,
            this.deps.authService,
            this.wsId,
            nextToken
        );
    };

    getWsClient() {
        return this.deps.dataClientService.getWsClientByKey('pgServer');
    };
}
